<template>
  <div>
    <div class="row">
      <div class="col">
        <div class="mb-1 div-border-payment p-1">
          <div class="d-flex align-items-center justify-content-between flex-wrap font-general-r">
            <span class="ml-2 color-blue">Contacto</span>
            <span class="color-primary">
              {{ is_auth ? user.email : address.contact_email }}
            </span>
            <v-btn
              v-if="!is_auth"
              @click="() => this.$emit('changeStep', 'information_shipping', 0)"
              class="nv-btn-small font-weight-bold"
              text
              elevation="0"
              color="accent"
            >
              Cambiar
            </v-btn>
          </div>
        </div>
        <div class="div-border-payment p-1 font-general-r">
          <div class="d-flex align-items-center justify-content-between flex-wrap">
            <span class="ml-2 color-blue">Enviar a</span>
            <div v-if="delivery_type != 'free'" class="color-primary">

              <span v-if="new_address">
                {{ address.street }}
                {{ 'Ext. '+address.no_outside }}
                {{ 'Int. '+address.no_inside }}
                {{ address.colony }}
              </span>
              <span v-if="!new_address && address_selected">
                {{ address_selected.street }}
                {{ 'Ext. '+address_selected.no_outside }}
                {{ 'Int. '+address_selected.no_inside }}
                {{ address_selected.colony }}
              </span>
            </div>
            <span class="color-primary" v-else>Recoger en tienda</span>

            <v-btn small @click="() => this.$emit('changeStep', 'information_shipping', 0)" class="nv-btn-small font-weight-bold" text elevation="0" color="accent">
              Cambiar
            </v-btn>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <p class="color-blue font-general-r">ENVÍO</p>
        <div class="mb-1 div-border-payment">
          <div class="d-flex align-items-center justify-content-between flex-wrap font-general-r">
            <v-radio-group v-model="delivery_type">
              <v-radio color="accent" class="ml-2" value="free">
                <template v-slot:label>
                  <strong class="accent--text">Recoger en tienda</strong>
                </template>
              </v-radio>
            </v-radio-group>
            <span class="color-primary mr-2">$ 0.00</span>
          </div>
        </div>
        <div class="div-border-payment">
          <v-overlay
            :absolute="true"
            :value="loading"
          >
            <v-progress-circular
              indeterminate
              size="20"
            ></v-progress-circular>
          </v-overlay>
          <div class="d-flex align-items-center justify-content-between flex-wrap font-general-r">
            <v-radio-group v-model="delivery_type">
              <v-radio color="accent" class="ml-2" value="cdmx">
                <template v-slot:label>
                  <strong class="accent--text">A domicilio</strong>
                </template>
              </v-radio>
            </v-radio-group>
            <span class="color-primary mr-2">
              {{ loading ? 'Calculando...' : currencyFormat(price_delivery) }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-50">
      <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
        <v-btn
          text
          color="primary"
          @click="() => this.$emit('changeStep', 'information_shipping', 1)"
        >
          <v-icon left>
            mdi-arrow-left
          </v-icon>
          Volver a información
        </v-btn>
      </div>
      <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12 text-right">
        <v-btn
          @click="() => this.$emit('changeStep', 'payment_data', 2)"
          color="primary"
          class="nv-btn nv-btn-large nv-btn-hover"
          elevation="0"
          :disabled="disabledButton"
        >
          CONTINUAR CON EL PAGO
        </v-btn>
      </div>
    </div>

    <PopupMessageShipping ref="popupMessageShipping"/>
    <PopupBeforePayment ref="popupBeforePayment" :price_delivery="price_delivery"/>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { currencyFormat } from '@/helpers'
import PopupBeforePayment from '@/components/store/PopupBeforePayment'
import HomeService from '@/services/home.service'

export default {
  props: ['disabled_button', 'address', 'new_address', 'address_selected', 'price_delivery', 'loading'],
  components: {
    PopupBeforePayment
  },
  data() {
    return {
      delivery_type: 'free',
      show_popup_message_shipping: false
    }
  },
  computed: {
    ...mapState(['is_auth', 'user', 'number_day']),
    closeLoading() {
      return this.loading
    },
    disabledButton() {
      return this.disabled_button
    }
  },
  watch: {
    closeLoading(newval) {
      if (!newval) {
        if (this.delivery_type == 'cdmx' && this.price_delivery > 0) {
          if (this.is_auth) {
            if (!this.user.subscription) {
              this.$refs.popupBeforePayment.openDialog()
            }
          } else {
            this.$refs.popupBeforePayment.openDialog()
          }
        }
      }
    },
    delivery_type(newval) {
      localStorage.setItem('option_delivery_mobile', newval)
      this.$emit('calculatedPriceDelivery', newval)
    }
  },
  methods: {
    currencyFormat(price) {
			return currencyFormat(price)
		},
    async getConfigSubscription() {
      const { data:res } = await HomeService.getConfigSubscription()
      if (res.on_config) {
        this.show_popup_message_shipping = true
        this.$refs.popupMessageShipping.openDialog()
      }
    }
  },
  mounted() {
    this.getConfigSubscription()
    /*let option_localstorage = localStorage.getItem('option_delivery_mobile')
    if (option_localstorage) {
      this.delivery_type = option_localstorage
    }*/
  }
}
</script>
